module.exports = __webpack_public_path__ + "static/media/icon-vuepay-white@2x.7dbdca02.png";